import { initializeApp } from 'firebase/app';
import { API_ENDPOINT, FREEDOM_CRM_API } from "../constants";
import { createUserWithEmailAndPassword, FacebookAuthProvider, getAuth, GoogleAuthProvider, signInWithPopup, User } from 'firebase/auth';
import { disableExclusiveModal, enableExclusiveModal } from './ExclusiveModal';
import PrettyNaoAnalytics from './AnalyticsService';

// Freedom CRM Integration
const FREEDOM_CRM_SITE_ID = 'prettynao.com';

async function sendToCRM(email: string) {
  PrettyNaoAnalytics.getPlausible()?.trackEvent('freedom_crm_email', {
    props: {
      email,
    }
  })

  try {
    const response = await fetch(`${FREEDOM_CRM_API}/new-contact`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, siteId: FREEDOM_CRM_SITE_ID })
    });
    return response.ok;
  } catch (error) {
    console.error('CRM Error:', error);
    return false;
  }
}

const firebaseConfig = {
  apiKey: "AIzaSyAoJBapsJgFZV1bFnrNZNlOkWvw_yfe4vs",
  authDomain: "prettynao-4f0b8.firebaseapp.com",
  projectId: "prettynao-4f0b8",
  storageBucket: "prettynao-4f0b8.firebasestorage.app",
  messagingSenderId: "673149796692",
  appId: "1:673149796692:web:832e732562b6f25d8388c1"
};

initializeApp(firebaseConfig);
const auth = getAuth();

async function sendFirebaseSessionToBackend(user: User) {
  const idToken = await user.getIdToken();

  await fetch(`${API_ENDPOINT}/sessionLogin`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({ idToken })
  });

  document.dispatchEvent(new CustomEvent('signin-complete'));
}

function handleIsSignedIn(email: string | null) {
  disableExclusiveModal()

  if (email) {
    PrettyNaoAnalytics.getPlausible()?.trackEvent('identify_email', {
      props: {
        email,
      }
    })
  }
}

function handleNotSignedIn() {
  enableExclusiveModal()
}

function showFacebookSignin() {
  const urlParams = new URLSearchParams(window.location.search);
  const fbSigninElement = document.getElementById('facebook-signin');
  const fbSigninModalElement = document.getElementById('modal-facebook-signin');

  /*
  if (urlParams.has('fbsignin')) {
    if (fbSigninElement) {
      fbSigninElement.classList.remove('hidden');
    }

    if (fbSigninModalElement) {
      fbSigninModalElement.classList.remove('hidden');
    }
  }
  */
}

window.addEventListener('DOMContentLoaded', () => {
  auth.onAuthStateChanged(u => {
    if (u) {
      handleIsSignedIn(u.email)
    } else {
      handleNotSignedIn()
    }
  })

  if (auth.currentUser !== null) {
    handleIsSignedIn(auth.currentUser.email)
  }

  showFacebookSignin()
});

const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

async function handleGoogleSignin(event) {
  const form = event.target;
  try {
    const result = await signInWithPopup(auth, googleProvider);
    await sendFirebaseSessionToBackend(result.user);

    const email = result.user.email;
    if (email && await sendToCRM(email)) {
      PrettyNaoAnalytics.getPlausible()?.trackEvent('signed_in_with_google', {
        props: {
          email,
        }
      })

      disableExclusiveModal()

      document.getElementById('signup_success')?.classList.remove('hidden');
      setTimeout(() => document.getElementById('signup_success')?.classList.add('hidden'), 3000);
    } else {
      document.getElementById('signup_error')?.classList.remove('hidden');
      setTimeout(() => document.getElementById('signup_error')?.classList.add('hidden'), 3000);
    }
  } catch (error) {
    console.error('Google Sign-In Error:', error);
  }
}

async function handleFacebookSignin(event) {
  const form = event.target;
  try {
    const result = await signInWithPopup(auth, facebookProvider);
    await sendFirebaseSessionToBackend(result.user);

    const email = result.user.email;
    if (email && await sendToCRM(email)) {
      PrettyNaoAnalytics.getPlausible()?.trackEvent('signed_in_with_facebook', {
        props: {
          email,
        }
      })

      disableExclusiveModal()

      document.getElementById('signup_success')?.classList.remove('hidden');
      setTimeout(() => document.getElementById('signup_success')?.classList.add('hidden'), 3000);
    } else {
      form.parentElement.querySelector('#signup_error').classList.remove('hidden');
      setTimeout(() => form.parentElement.getElementById('signup_error').classList.add('hidden'), 3000);
    }
  } catch (error) {
    console.error('Google Sign-In Error:', error);
  }
}

// Email Signup Handler

async function handleEmailSignup(event) {
  event.preventDefault();
  const form = event.target;
  const submitButton = form.querySelector('button[type="submit"]');
  submitButton.disabled = true;
  submitButton.textContent = 'Creating account...';

  const email = form.email.value.trim();
  const password = form.password.value.trim();
  const confirmPassword = form.confirmPassword.value.trim();

  if (password !== confirmPassword) {
    form.parentElement.querySelector('#signup_error')?.classList.remove('hidden');
    form.parentElement.querySelector('#signup_error').textContent = "Passwords do not match.";
    setTimeout(() => {
      form.parentElement.querySelector('#signup_error')?.classList.add('hidden');
    }, 3000);
    submitButton.disabled = false;
    submitButton.textContent = submitButton.dataset.originalText;
    return;
  }

  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const userEmail = userCredential.user.email;

    if (userEmail && await sendToCRM(userEmail)) {
      PrettyNaoAnalytics.getPlausible()?.trackEvent('signed_up_with_email', {
        props: { email: userEmail }
      });

      disableExclusiveModal();
      form.reset();

      document.getElementById('signup_success')?.classList.remove('hidden');
      setTimeout(() => document.getElementById('signup_success')?.classList.add('hidden'), 3000);
    } else {
      throw new Error("CRM failed");
    }
  } catch (error) {
    console.error("Firebase Email Signup Error:", error);
    const errBox = form.parentElement.querySelector('#signup_error');
    if (errBox) {
      errBox.textContent = error.message || "An error occurred. Please try again.";
      errBox.classList.remove('hidden');
      setTimeout(() => errBox.classList.add('hidden'), 3000);
    }
  }

  submitButton.disabled = false;
  submitButton.textContent = submitButton.dataset.originalText;
}

document.querySelectorAll('form#modal-email-signup').forEach(form => {
  const submitButton = form.querySelector('button[type="submit"]');
  if (submitButton) {
    submitButton.dataset.originalText = submitButton.textContent;
    form.addEventListener('submit', handleEmailSignup);
  }
});

document.getElementById('google-signin')?.addEventListener('click', handleGoogleSignin);
document.getElementById('modal-google-signin')?.addEventListener('click', handleGoogleSignin);

document.getElementById('facebook-signin')?.addEventListener('click', handleFacebookSignin);
document.getElementById('modal-facebook-signin')?.addEventListener('click', handleFacebookSignin);
